<template>
    <div class="loading">
        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
    </div>
</template>

<script>
export default {
    name: 'loading',

}
</script>

<style scoped>
.loading {
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 2000;
    left: 0;
    background: rgba(0,0,0,0.2);
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
